import './style.sass';
import Image from 'next/image';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const CloudSystem = () => {
    return (
        <div className="aimed-cloud">
            <FullWrapper isMargin={false}>
                <div className="aimed-cloudWrapper">
                    <div className="aimed-cloudFramesList">
                        <div className="aimed-cloudFrameItem">
                            <Image
                                src="/images/pic/aimed/f3.png"
                                alt="cloud system"
                                width={1200}
                                height={692}
                                className="aimed-markerImg"
                            />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default CloudSystem;
